/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Gymnasium_Oberursel2Inputs */

const en__field_enum_gymnasium_oberursel2 = /** @type {(inputs: _Field_Enum_Gymnasium_Oberursel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oberursel`)
};

const de__field_enum_gymnasium_oberursel2 = /** @type {(inputs: _Field_Enum_Gymnasium_Oberursel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gymnasium Oberursel`)
};

/**
* | output |
* | --- |
* | "Oberursel" |
*
* @param {_Field_Enum_Gymnasium_Oberursel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_gymnasium_oberursel2 = /** @type {((inputs?: _Field_Enum_Gymnasium_Oberursel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Gymnasium_Oberursel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_gymnasium_oberursel2(inputs)
	return de__field_enum_gymnasium_oberursel2(inputs)
});
export { _field_enum_gymnasium_oberursel2 as "_field_enum_Gymnasium_Oberursel" }